// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-KUfM","centered":"styles_centered__4oPIL","space-between":"styles_space-between__HlEvl","right":"styles_right__TqMeH","marginTop":"styles_marginTop__EBr8I"};